import { render } from "./ControleDePlanodeAção.vue?vue&type=template&id=9dd44a74"
import script from "./ControleDePlanodeAção.vue?vue&type=script&lang=js"
export * from "./ControleDePlanodeAção.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__